<div *ngIf="meta?.buzzsprout_player_id" id="{{meta.buzzsprout_player_id}}"></div>